import { FC } from 'react'
import { ContentExperiment } from '@/page/ContentExperiment'
import { ContentItem } from '@/page/PageContent/ContentItem'
import { isDraft } from '@/services/ContentfulService'
import { isContentExperimentModel, isInlineExperimentModel, PageDataContext } from '@/services/RenderService'
import { InlineExperimentContentItemsItem, Maybe, PageContentItem } from '@/types/codegen-contentful'
import { InlineExperiment } from '../InlineExperiment'

interface Props {
  content?: Maybe<PageContentItem>
  pageDataContext: PageDataContext
  containerPosition?: number
}

export const PageContent: FC<Props> = ({ content, pageDataContext, containerPosition = 0 }) => {
  if (!content || isDraft(content)) return null
  if (isInlineExperimentModel(content) && content.experimentName && content.contentItemsCollection?.items) {
    return (
      <InlineExperiment
        experimentName={content.experimentName}
        contentItems={content.contentItemsCollection.items as InlineExperimentContentItemsItem[]}
        pageDataContext={pageDataContext}
        containerPosition={containerPosition}
      />
    )
    // TODO: could this be combined/replaced by InlineExperiment?
  } else if (isContentExperimentModel(content)) {
    return (
      <ContentExperiment content={content} pageDataContext={pageDataContext} containerPosition={containerPosition} />
    )
  } else {
    return <ContentItem content={content} pageDataContext={pageDataContext} containerPosition={containerPosition} />
  }
}
